import Menu from '../modules/components/menu';
import Header from '../modules/components/header';
import Preloader from '../modules/components/preloader';

function entry () {
  window.__DOMReady.then(() => {

    /* Reload */

    const aspect = window.innerWidth / window.innerHeight > 1 ? 'landscape' : 'portrait';
    const deviceWidth  = window.innerWidth >= 1200 ? 'desktop' : 'mobile';

    window.addEventListener('resize', (event) => {
        event.stopPropagation();

        const newAspect = window.innerWidth / window.innerHeight > 1 ? 'landscape' : 'portrait';
        const newDeviceWidth  = window.innerWidth >= 1200 ? 'desktop' : 'mobile';

        if (aspect !== newAspect || deviceWidth !== newDeviceWidth) {
            window.location.reload();
        }
    });

    /* Preloader */

    new Preloader('.site-preloader', 2000);

    /* Site Navigation */

    const logotype = document.querySelector('.custom-logo-link');
    const anchor = document.querySelector('.site-header--anchor');

    const callback = {
      open:  () => {
        if (logotype) logotype.classList.add('opened');
        if (anchor) anchor.classList.add('opened');
      },
      close: () => {
        if (logotype) logotype.classList.remove('opened');
        if (anchor) anchor.classList.remove('opened');
      }
    }

    new Menu({ menu: '.site-header--navigation' }, 1199, callback);

    new Header();
  });
}

window.addEventListener('DOMContentLoaded', entry);
